import type {
  ActiveSearchTarget,
  ActiveSearchTargetSuggestion,
  ActiveSearchTargetsApi,
  CreateActiveSearchTargetInput,
  UpdateActiveSearchTargetInput,
} from "@/features/job-tracker/activeSearchTargets";
import { httpClient } from "@/shared/api/httpClient";

function rebuildSearchProfile(): void {
  void httpClient.post("/api/jobs/search-profile/rebuild", {}).catch(() => {
    // The target mutation has already succeeded. Profile/Job Tracker surfaces
    // expose a retry when the user next edits preferences.
  });
}

export const realActiveSearchTargetsApi: ActiveSearchTargetsApi = {
  async list(): Promise<ActiveSearchTarget[]> {
    return httpClient.get<ActiveSearchTarget[]>("/api/active-search-targets");
  },

  async create(input: CreateActiveSearchTargetInput): Promise<ActiveSearchTarget> {
    const target = await httpClient.post<ActiveSearchTarget>(
      "/api/active-search-targets",
      input as unknown as Record<string, unknown>,
    );
    rebuildSearchProfile();
    return target;
  },

  async update(id: string, input: UpdateActiveSearchTargetInput): Promise<ActiveSearchTarget> {
    const target = await httpClient.patch<ActiveSearchTarget>(
      `/api/active-search-targets/${encodeURIComponent(id)}`,
      input as unknown as Record<string, unknown>,
    );
    rebuildSearchProfile();
    return target;
  },

  // 204 No Content per backend controller. httpClient returns undefined.
  async archive(id: string): Promise<void> {
    await httpClient.del<void>(`/api/active-search-targets/${encodeURIComponent(id)}`);
    rebuildSearchProfile();
  },

  async suggestions(): Promise<ActiveSearchTargetSuggestion[]> {
    return httpClient.get<ActiveSearchTargetSuggestion[]>("/api/active-search-targets/suggestions");
  },
};
